var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cabecalho',{attrs:{"title":"SUPRIMENTOS_LANCAMENTOS_NF.DADOS_GERAIS","description":"SUPRIMENTOS_LANCAMENTOS_NF.NOTA_FISCAL_TAB_ITENS_DADOS_DESCRICAO"}}),_c('form-dados',{attrs:{"form":_vm.form},on:{"refs":_vm.capturarRefs,"atualiza-cnpj-fornecedor":_vm.atualizaCnpjFornecedor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }